import { render, staticRenderFns } from "./TimeSlotsSlider.vue?vue&type=template&id=b89cac4c&"
import script from "./TimeSlotsSlider.vue?vue&type=script&lang=js&"
export * from "./TimeSlotsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports